<template lang="pug">
b-container(fluid)
    b-row(v-if="structures.size !== 0")
        b-col
            form
                div.form-group.row
                    label(class="col-md-2" for="structure") Select structure:
                    select(class="form-control col-md-2"
                        id="structure-select"
                        v-model="selectedStructure"
                        @change = "onStructureSelect()")
                        option(v-for="item in structures"
                            :key="item.pdbId"
                            v-bind:value="item") {{ item.pdbId }}
            molecular-structure(v-if="structures.size !== 0 && selectedStructure !== null"
                v-bind:structure="selectedStructure" )
    b-row
        b-table(hover
            v-if="structures.size !== 0"
            :items="structures"
            :fields="fields")
</template>

<script>
import axios from 'axios'
import MolecularStructure from './MolecularStructure.vue'
export default {
    name: 'Structures',
    components: {
        MolecularStructure
    },
    data() {
        return {
            msg: 'Structures tab',
            structures: [],
            selectedStructure: null,
            fields: [
                'pdbId',
                'pdbName',
                'method',
                'resolution',
                'stoichiometry'
            ]
        }
    },
    beforeMount: function() {
        if (this.$store.state.proteinId == null) {
            this.getProtein()
        }
        this.getStructures()
    },
    mounted: function() {},
    methods: {
        async getStructures() {
            const apiBaseUrl = '/scop3ptm/api/get-structures'
            const response = await axios
                .get(apiBaseUrl, {
                    params: { protein_id: this.$store.state.proteinId }
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response)
                    }
                })
            this.structures = response.data.structures
            this.selectedStructure = this.structures[0]
            this.getStructureModifications(this.selectedStructure.id)
        },
        async getStructureModifications(structure_id) {
            console.log('getStructureMods', structure_id)
            const apiBaseUrl = '/scop3ptm/api/get-structure-modifications'
            const response = await axios
                .get(apiBaseUrl, {
                    params: { 
                        protein_id: this.$store.state.proteinId,
                        structure_id: structure_id
                    }
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response)
                    }
                })
            this.selectedStructure.structureModificationsList = response.data.structureModifications
        },
        onStructureSelect() {
            this.getStructureModifications(this.selectedStructure.id)
        },
        // move to a service
        async getProtein() {
            const apiBaseUrl = '/scop3ptm/api/protein'
            const response = await axios
                .get(apiBaseUrl, {
                    params: { protein: this.$route.params.protein }
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response)
                    }
                });
            this.$store.commit('setProteinId', response.data.proteins[0].id)
        }
    }
}
</script>
